import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthConsumer } from 'contexts/auth'

const AdminRoute = ({ component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
    <AuthConsumer>
      {({ isAuthenticated, isAdmin }) => (
        <Route 
          render={
            props =>
              isAuthenticated && isAdmin
              ? <Component {...props} />
              : <Redirect to='/' />
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  )} />
)

export default AdminRoute